import {
  type FieldValues,
  type FieldPath,
  Controller,
  type ControllerProps,
} from "react-hook-form";

import {
  ControlledFormControlWrapper,
  type ControlledFormControlWrapperProps,
} from "@apac/form-ui";

export type UncontrolledFormControlWrapperProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = ControlledFormControlWrapperProps & ControllerProps<TFieldValues, TName>;

export const UncontrolledFormControlWrapper = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  className,
  render,
  ...props
}: UncontrolledFormControlWrapperProps<TFieldValues, TName>): JSX.Element => {
  return (
    <Controller
      {...props}
      render={(context) => {
        return (
          <ControlledFormControlWrapper
            className={className}
            error={context.fieldState.error?.message}
            {...props}
          >
            {/* Call, do not mount: `render` is usually an inline arrow, so
                using it as a component would remount the input (and drop
                focus) on every parent re-render. */}
            {render(context)}
          </ControlledFormControlWrapper>
        );
      }}
    />
  );
};
